import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import localforage from "localforage";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import maybeLogo from "../../assets/icons/maybe-icon.png";
import { useUserInfo } from "../../context/user";
import { useAppServices } from "../../hook/services";

const FreeTrail = () => {
  const Service = useAppServices();
  const [whitelabel, setwhitelabel] = useState([]);
  const [loading, setLoading] = useState(false);
  const [messages, setmessages] = useState("");
  const [showVerifyEmail, setShowVerifyEmail] = useState(false);
  const navigate = useNavigate();
  const [ inputs, setInputs ] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleFormChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  const agencyData = useUserInfo()[11];

  const getting_whitelable_domain = async () => {
    const currentURL = window.location.href;
    const urlObject = new URL(currentURL);
    const domain = urlObject.hostname;
    const payload = {
      domain: domain,
    };
    const { response } = await Service.agency.getwhitelabel({
      payload: payload,
    });
    if (response) {
      setwhitelabel(response.data);
    }
  };

  useEffect(() => {
    getting_whitelable_domain();
  }, []);

  const updateMetaInfo = () => {
    const newFavicon = agencyData?.Customization?.chatapp_logo || maybeLogo;

    const link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/x-icon";
    link.href = newFavicon;

    const head = document.head || document.getElementsByTagName("head")[0];
    const existingFavicon = document.querySelector("link[rel*='icon']");

    if (existingFavicon) {
      head.removeChild(existingFavicon);
    }

    head.appendChild(link);
  };

  useEffect(() => {
    updateMetaInfo();
    document.body.style.background = "white";
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = inputs;

    if (!email) {
      setmessages("Please enter your email");
      return false;
    }
    if (!password) {
      setmessages("Please enter your password");
      return false;
    }

    setLoading(true);

    const payload = {
      email: email,
      agency_id: whitelabel?._id || "6683d9932ad0d58aead153d0",
      // agency_id: "6739f1be347a7f5974735cec",
      password: e.target.password.value,
    };

    try {
      const { response } = await Service.accounts.create_busines_account({
        payload: payload,
      });
      if (response) {
        setLoading(false);
        if (response.status === 200) {
          setShowVerifyEmail(true);
        }
        setmessages(response.message);
      }
    } catch (error) {
      setmessages("An error occurred while creating your account");
      setShowVerifyEmail(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="!bg-white">
        <div
          className="container-main h-screen"
          style={{ background: "white" }}
        >
          <div
            className="flex justify-center items-center h-full"
            style={{ background: "white" }}
          >
            <div className="">
              <p className="success-alert">{messages !== "" && messages}</p>
              <div>
                <form onSubmit={handleSubmit} className="loginForm">
                  <div className="mb-2">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      size="large"
                      onChange={handleFormChange}
                      value={inputs.email}
                    />
                  </div>

                  <div className="mb-2 relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      size="large"
                      className="w-full pr-10"
                      value={inputs.password}
                      onChange={handleFormChange}
                    />

                    {showPassword ? (
                      <VisibilityOffOutlinedIcon
                        onClick={handleShowPassword}
                        className="text-[#8692A6]"
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      />
                    ) : (
                      <RemoveRedEyeOutlinedIcon
                        className="text-[#8692A6]"
                        onClick={handleShowPassword}
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                        }}
                      />
                    )}
                  </div>
                  <div className="mt-5" style={{ textAlign: "right" }}>
                    <button
                      className={`w-full text-center py-2 rounded font-medium ${
                        inputs.email === "" && inputs.password === ""
                          ? "bg-[#F5F5F5] !text-black border !border-[#D9D9D9]"
                          : "bg-black text-white !border-black border"
                      }`}
                      disabled={inputs.email === "" && inputs.password === ""}
                      type="submit"
                    >
                      {loading ? "Loading..." : "Sign Up"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FreeTrail;
